export const appConfig = {
  env: process.env.REACT_APP_ENV,
  ip: process.env.REACT_APP_API_ENDPOINT,
  imgServerip: process.env.REACT_APP_IMG_API_ENDPOINT,
};

export const momentDateFormat = process.env.momentDateFormat;
export const GOOGLE_MAPS_API = process.env.REACT_APP_GOOGLE_MAPS_API;

export const REACT_APP_PUSHER_KEY = process.env.REACT_APP_PUSHER_KEY;
export const REACT_APP_RAZORPAY_KEY = process.env.REACT_APP_RAZORPAY_KEY;